import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const WindGustIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M22.5 7.875C22.5 10.5675 20.4075 12.75 17.8275 12.75H3.0285C2.59875 12.75 2.25 12.3862 2.25075 11.9377C2.25075 11.4885 2.5995 11.1248 3.03 11.1248H17.8267C19.5472 11.1248 20.9422 9.66975 20.9422 7.875C20.9422 6.08025 19.5472 4.62525 17.8267 4.62525C16.1062 4.62525 14.7112 6.08025 14.7112 7.875C14.7112 8.3235 14.3625 8.68725 13.9327 8.68725C13.5022 8.68725 13.1535 8.3235 13.1535 7.875C13.1535 5.1825 15.246 3 17.8275 3C20.4075 3 22.5 5.1825 22.5 7.875Z'
                fill='currentColor'
            />
            <Path
                d='M12 6.375C12 7.82475 10.7812 9 9.2775 9H2.27775C1.848 9 1.5 8.664 1.5 8.25C1.5 7.836 1.848 7.5 2.27775 7.5H9.2775C9.92175 7.5 10.4445 6.996 10.4445 6.375C10.4445 5.754 9.9225 5.25 9.2775 5.25C9.05143 5.248 8.82963 5.31163 8.639 5.43317C8.44837 5.55472 8.29709 5.72895 8.2035 5.93475C8.0355 6.315 7.57875 6.49275 7.1835 6.33C7.09071 6.29391 7.00616 6.23948 6.9349 6.16996C6.86364 6.10044 6.80713 6.01726 6.76876 5.9254C6.73039 5.83353 6.71095 5.73487 6.71159 5.63532C6.71223 5.53576 6.73295 5.43736 6.7725 5.346C7.197 4.386 8.1765 3.75 9.2775 3.75C10.7812 3.75 12 4.92525 12 6.375Z'
                fill='currentColor'
            />
            <Path
                d='M18.7155 17.25C18.7155 16.0072 17.6842 15 16.413 15H4.51725C4.0935 15 3.75 14.664 3.75 14.25C3.75 13.836 4.09275 13.5 4.518 13.5H16.413C18.5325 13.5 20.25 15.1792 20.25 17.25C20.25 19.3207 18.5317 21 16.413 21C14.2935 21 12.5753 19.3207 12.5753 17.25C12.5753 16.836 12.9195 16.5 13.3433 16.5C13.767 16.5 14.1105 16.836 14.1105 17.25C14.1105 18.4928 15.141 19.5 16.413 19.5C17.6842 19.5 18.7155 18.4928 18.7155 17.25Z'
                fill='currentColor'
            />
        </>
    ),
})

WindGustIcon.displayName = 'WindGustIcon'
